import { combineReducers } from '@reduxjs/toolkit';
import auth from './authReducer';
import usersAdmin from './usersAdminReducer';
import invites from './invitesReducer';
import roles from './rolesReducer';
import apiKeys from './apiKeysReducer';

// Only auth and the account-management slices live in Redux. The operational
// screens (bookings, quotes, teams) hold their own state with hooks: they are
// short-lived views over server data that must be re-read after every action,
// and putting that in a global store buys nothing but stale copies.
export default combineReducers({ auth, usersAdmin, invites, roles, apiKeys });
